/**
 * Inside/Insight module image URLs — use stored secure_url exactly as saved.
 * No API prefix, no Cloudinary transforms, no Gallery config.
 */

import { resolveApiBase } from "./apiClient";

export function getInsightImageUrl(imagePath) {
  if (!imagePath) {
    console.warn("[Frontend] No image path provided to getInsightImageUrl");
    return null;
  }
  
  const pathStr = String(imagePath).trim();

  // If it's already a full URL (Cloudinary or otherwise)
  if (pathStr.startsWith("http://") || pathStr.startsWith("https://")) {
    if (process.env.NODE_ENV === "development") {
      console.log(`[Frontend] Rendering EXACT URL from DB: ${pathStr}`);
    }
    return pathStr;
  }

  // Handle local relative paths (Legacy)
  const base = resolveApiBase();
  
  // Clean up the path - remove leading slashes and redundant 'uploads/'
  let cleanPath = pathStr.replace(/^\/+/, "");
  if (cleanPath.startsWith("uploads/")) {
    cleanPath = cleanPath.replace(/^uploads\//, "");
  }

  const finalUrl = `${base.replace(/\/$/, "")}/uploads/${cleanPath}`;
  console.log(`[Frontend] Rendering LOCAL URL: ${finalUrl} (Original: ${imagePath})`);
  return finalUrl;
}

export function logInsightImageError(item, event) {
  console.error("[Frontend] IMAGE FAILED TO LOAD", {
    id: item?._id,
    title: item?.title,
    image: item?.image,
    attemptedSrc: event?.target?.src,
  });
}
